document.addEventListener('DOMContentLoaded', () => {
  if (!customElements.get('popular-products')) {
    class popularProducts extends HTMLElement {
      constructor() {
        super();

        this.tabs = this.querySelectorAll('.tab-product .tab-item');
        this.tabContents = this.querySelectorAll('.content-product');
        this.slides = [];

        if (this.tabs) {
          this.tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => {
              this.tabContents.forEach((content) => {
                content.classList.remove('active');
              });

              this.tabs.forEach((tab) => {
                tab.classList.remove('active');
              });

              this.tabContents[index].classList.add('active');
              tab.classList.add('active');
            });
          });
        }

        // if window enable swiper on resize
        window.addEventListener('resize', () => {
          this.onResize();
        });

        this.onResize();
      }

      onResize() {
        if (window.innerWidth < 878) {
          this.enableSwiper();
        } else {
          this.slides.forEach((slide) => {
            if (slide) slide.destroy();
          });
        }
      }

      enableSwiper() {
        this.tabContents.forEach((content, index) => {
        /*   this.slides[index] = new Swiper(content, {
            slidesPerView: 1,
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
          }); */

          if (this.slides[index]) {
            this.slides[index].on('reachEnd', () => {
              if (this.slides[index].realIndex > 0) {
                this.classList.remove('active');
              } else {
                this.classList.add('active');
              }
            });
          }
        });
      }
    }

    customElements.define('popular-products', popularProducts);
  }
});
